var _g, _path, _g2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 261,
    viewBox: "0 0 395 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_13_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H383C389.627 0 395 5.37258 395 12V249C395 255.627 389.627 261 383 261H12C5.37259 261 0 255.627 0 249V12Z",
    fill: "#FF583D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_281",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 395,
    height: 261
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H383C389.627 0 395 5.37258 395 12V249C395 255.627 389.627 261 383 261H12C5.37259 261 0 255.627 0 249V12Z",
    fill: "#FF583D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.929 6.90046C548.667 27.8581 610.871 40.9137 641.457 78.0191C672.387 115.124 672.043 175.936 636.989 207.544C601.936 239.496 532.859 242.245 486.12 282.442C439.382 322.983 415.325 401.317 373.398 426.054C331.471 450.447 272.017 421.244 218.405 383.108C164.793 344.628 117.367 297.559 127.334 250.147C137.644 202.734 206.033 154.978 232.495 100.695C259.301 46.0673 244.18 -15.4315 263.769 -45.3219C283.358 -75.2124 337.313 -73.4945 380.271 -58.3775C423.23 -42.9169 454.847 -14.4008 501.929 6.90046Z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9289 -79.0995C68.6674 -58.1419 130.871 -45.0863 161.457 -7.9809C192.387 29.1245 192.043 89.9361 156.989 121.544C121.936 153.496 52.8588 156.245 6.12027 196.442C-40.6182 236.983 -64.6748 315.317 -106.602 340.054C-148.529 364.447 -207.983 335.244 -261.595 297.108C-315.207 258.628 -362.633 211.559 -352.666 164.147C-342.356 116.734 -273.967 68.9784 -247.505 14.6946C-220.699 -39.9327 -235.82 -101.431 -216.231 -131.322C-196.642 -161.212 -142.687 -159.495 -99.7286 -144.378C-56.7705 -128.917 -25.1533 -100.401 21.9289 -79.0995Z",
    fill: "#FF755F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.845 136H147.085V125.26H146.985L142.305 136H139.265L134.525 125.12H134.405V136H130.825V121.72H136.805L140.745 131.14H140.865L144.745 121.72H150.845V136ZM153.599 136V121.72H157.359V136H153.599ZM176.743 121.72V136H172.423L163.783 126.2H163.683V136H160.103V121.72H164.523L173.043 131.4H173.143V121.72H176.743ZM195.278 124.82H188.878V136H185.118V124.82H178.738V121.72H195.278V124.82ZM220.961 121.72V136H216.641L208.001 126.2H207.901V136H204.321V121.72H208.741L217.261 131.4H217.361V121.72H220.961ZM232.576 121.3C235.55 121.3 237.856 121.933 239.496 123.2C241.15 124.467 241.976 126.353 241.976 128.86C241.976 131.367 241.15 133.253 239.496 134.52C237.856 135.787 235.55 136.42 232.576 136.42C229.603 136.42 227.29 135.787 225.636 134.52C223.996 133.253 223.176 131.367 223.176 128.86C223.176 126.353 223.996 124.467 225.636 123.2C227.29 121.933 229.603 121.3 232.576 121.3ZM232.576 133.36C234.283 133.36 235.583 132.98 236.476 132.22C237.383 131.447 237.836 130.327 237.836 128.86C237.836 127.393 237.383 126.28 236.476 125.52C235.583 124.747 234.283 124.36 232.576 124.36C230.87 124.36 229.563 124.747 228.656 125.52C227.763 126.28 227.316 127.393 227.316 128.86C227.316 130.327 227.763 131.447 228.656 132.22C229.563 132.98 230.87 133.36 232.576 133.36ZM257.299 136L254.439 126.22H254.339L251.459 136H246.879L242.359 121.72H246.499L249.299 131.64H249.419L252.299 121.72H256.499L259.399 131.64H259.499L262.299 121.72H266.399L261.839 136H257.299Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13_281",
    x: -100,
    y: -100,
    width: 595,
    height: 461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13_281",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout3);
export default __webpack_public_path__ + "static/media/About3.572c9e01c02f147d55ad625419794bb5.svg";
export { ForwardRef as ReactComponent };